import React, { cloneElement } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

import Admin from 'hive-admin';
import PageArchiveTable from 'hive-admin/src/components/PageArchiveTable';

import PrefixedQueryBuilder from './PrefixedQueryBuilder';

const GlobalStyle = createGlobalStyle`
  form[section="top"] .ant-divider.ant-divider-horizontal {
    display: none;
  }
`;

const FiltersHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
`;

export default class PageStatistics extends PageArchiveTable {
  static create(config) {
    const prefixedQueryBuilder = new PrefixedQueryBuilder();
    const initialPage = super.create(config);
    return {
      ...initialPage,
      render: (...args) => {
        const content = initialPage.render(...args);
        const newContent = cloneElement(
          content,
          { builder: prefixedQueryBuilder },
        );
        return newContent;
      },
    };
  }

  renderArchiveContent() {
    return this.props.renderStats ? this.props.renderStats(this.props) : null;
  }

  renderFound() {
    const params = this.props.getFilterParams();
    return (
      <>
        <GlobalStyle />
        {this.renderHeader(this.props)}
        <FiltersHeaderWrapper>
          {this.renderFilters(params, 'topHeader')}
          {
            `${this.props.searchParams.compare}` !== '2'
            ? this.renderFilters(params, 'top')
            : this.renderFilters(params, 'topCompare')
          }
        </FiltersHeaderWrapper>
        {this.renderArchiveContent()}
        {this.renderFilters(params, 'bottom')}
      </>
    );
  }
}

Admin.addToLibrary('PageStatistics', config => PageStatistics.create({
  ...config,
  getArchiveQueryMode: () => 'paginated',
}));
